import { render, staticRenderFns } from "./PolicyText.vue?vue&type=template&id=f3444112&scoped=true&"
import script from "./PolicyText.vue?vue&type=script&lang=js&"
export * from "./PolicyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3444112",
  null
  
)

export default component.exports